import { AxiosResponse } from 'axios';
import { orderBy, select } from 'utils/dynamic';
import { API, apiRtk, rtkAdapterDynamicToSource } from 'utils/service';
import { IProductBrand } from '__generated__/api';

type Source = Pick<IProductBrand, 'id' | 'isActive'> & { title: string }
export const apiProductBrands = apiRtk.injectEndpoints({
  endpoints: (build) => ({
    getSourceProductBrands: build.query<Array<Source>, void>({
      queryFn: async () => {
        const res = await API.api.productBrandsGetAllDynamicCreate({
          select: select('id', 'catalogName as title', 'isActive'),
          orderBy: orderBy('catalogName', 'asc'),
        });

        return rtkAdapterDynamicToSource(res) as AxiosResponse<
          Array<Source>
        >;
      },
    }),
  }),
});
